import React from "react";
import EiaLink from "../../components/tables/EiaLink";

const getLink = function (amount, name, link) {
    const label = amount ? amount + " x " + name : name;

    return <EiaLink name={label} link={link} isExternal={true} />
}



export const zanRune = function (amount) {
    return getLink(amount, "Zan", "https://www.wowhead.com/diablo-4/item/zan-1968550");
}

export const zecRune = function (amount) {
    return getLink(amount, "Zec", "https://www.wowhead.com/diablo-4/item/zec-1968672");
}

export const igniRune = function (amount) {
    return getLink(amount, "Igni", "https://www.wowhead.com/diablo-4/item/igni-2165977");
}

export const naguRune = function (amount) {
    return getLink(amount, "Nagu", "https://www.wowhead.com/diablo-4/item/nagu-2155997");
}

export const chacRune = function (amount) {
    return getLink(amount, "Chac", "https://www.wowhead.com/diablo-4/item/chac-2166985");
}
